// | Prelude with Specular extension
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
const wempty = /* #__PURE__ */ Specular$dInternal$dRIO.pureImpl();
export {wempty};
